import { offerMeteredTransforms } from "@stores/config/utils";
import { AddOnCard } from "@addons/components/AddOnCard";
import { TransformsAdvancedMeteredUpsell } from "@addons/components/TransformsAdvancedMeteredUpsell";
import { LegacyTransformsManageLink } from "@addons/components/LegacyTransformsManageLink";
import { TransformsUsagePanel } from "@addons/components/TransformsUsagePanel";
import { useAddOnContext } from "../hooks";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";
import { subscribedBaseFee } from "../utils";

export function ManageCard({
  addOn: ctx,
}: IAddOnSlotProps<IMeteredAddOnDescriptor>) {
  const advanced = useAddOnContext("transforms-advanced-metered");

  return (
    <AddOnCard
      isYearly={ctx.isYearly}
      productType="transforms-basic-metered"
      title={ctx.title}
      price={subscribedBaseFee(ctx)}
      usage={
        <TransformsUsagePanel
          addOn={ctx}
          upsell={
            offerMeteredTransforms(ctx.config) && (
              <TransformsAdvancedMeteredUpsell addOn={advanced} />
            )
          }
        />
      }
      extra={<LegacyTransformsManageLink addOn={ctx} />}
    />
  );
}
